var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPwcWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.053,
    height: 33.229,
    viewBox: "0 0 32.053 33.229",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3869",
    "data-name": "\\uD328\\uC2A4 3869",
    d: "M312.932,56.079c-.247-.108-.5-.2-.749-.281a8.615,8.615,0,1,0-5.143-.014,8.373,8.373,0,0,0-5.144,4.61,8.179,8.179,0,0,0-4.977-4.239,8.579,8.579,0,0,0,5.433-2.41,10.093,10.093,0,0,1-1.044-1.649,6.717,6.717,0,1,1,.006-9.044,10.031,10.031,0,0,1,1.045-1.647,8.61,8.61,0,1,0-8.517,14.4h-5.458L286.19,72.185h3.857v-.006h4.42v-.015h.1a8.157,8.157,0,0,0,7.423-4.791,8.386,8.386,0,0,0,10.724,4.2l-.678-1.72a6.555,6.555,0,0,1-7.449-10.324l10.361,9.023.907.813a8.408,8.408,0,0,0-2.929-13.291ZM294.571,70.562A6.561,6.561,0,1,1,301.132,64,6.561,6.561,0,0,1,294.571,70.562Zm8.343-22.992a6.717,6.717,0,1,1,6.718,6.717A6.718,6.718,0,0,1,302.914,47.57ZM315.59,66.4c-.062.141-.127.279-.2.414l-9.61-8.368A6.554,6.554,0,0,1,315.59,66.4Z",
    transform: "translate(-286.19 -38.958)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPwcWhite);
export default __webpack_public_path__ + "static/media/pwc-white.cfc3951a.svg";
export { ForwardRef as ReactComponent };